"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEventProvider = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var EventDispatcher_1 = require("./EventDispatcher");
var GlobalEventProvider = (function () {
    function GlobalEventProvider() {
        this.listenersMap = {};
    }
    GlobalEventProvider.prototype.destroy = function () {
        this.removeAllListeners();
    };
    GlobalEventProvider.prototype.dispatch = function (eventName, data) {
        this._dispatcher.emit(eventName, data);
    };
    GlobalEventProvider.prototype.addListener = function (eventName, fn) {
        if (this.mapListenerToEvent(eventName, fn, this.listenersMap)) {
            this._dispatcher.on(eventName, fn, this);
        }
        else {
            console.warn("Listener " + fn + " for event " + eventName + " is already exists");
        }
    };
    GlobalEventProvider.prototype.addListenerOnce = function (eventName, fn) {
        var _this = this;
        var onceCallback = function (data) {
            fn.call(_this, data);
            _this.removeListener(eventName, onceCallback);
        };
        this.addListener(eventName, onceCallback);
    };
    GlobalEventProvider.prototype.removeListener = function (eventName, fn) {
        if (this.unMapListenerToEvent(eventName, fn, this.listenersMap)) {
            this._dispatcher.off(eventName, fn, this);
        }
        else {
            console.warn(fn + " is not a listener for event " + eventName);
        }
    };
    GlobalEventProvider.prototype.removeListeners = function (eventName) {
        var e_1, _a;
        var listenersForEvent = this.listenersMap[eventName];
        if (listenersForEvent) {
            try {
                for (var listenersForEvent_1 = tslib_1.__values(listenersForEvent), listenersForEvent_1_1 = listenersForEvent_1.next(); !listenersForEvent_1_1.done; listenersForEvent_1_1 = listenersForEvent_1.next()) {
                    var fn = listenersForEvent_1_1.value;
                    this._dispatcher.off(eventName, fn, this);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (listenersForEvent_1_1 && !listenersForEvent_1_1.done && (_a = listenersForEvent_1.return)) _a.call(listenersForEvent_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            delete this.listenersMap[eventName];
        }
        else {
            console.warn("There are no any listeners for event " + eventName);
        }
    };
    GlobalEventProvider.prototype.removeAllListeners = function () {
        var e_2, _a;
        try {
            for (var _b = tslib_1.__values(Object.keys(this.listenersMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                this.removeListeners(key);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.listenersMap = {};
    };
    GlobalEventProvider.prototype.hasListeners = function () {
        return Object.keys(this.listenersMap).length !== 0;
    };
    GlobalEventProvider.prototype.mapListenerToEvent = function (eventName, fn, map) {
        var listenersForEvent = map[eventName];
        if (!listenersForEvent) {
            listenersForEvent = [fn];
            map[eventName] = listenersForEvent;
        }
        else {
            if (listenersForEvent.indexOf(fn) > -1) {
                return false;
            }
            else {
                listenersForEvent.push(fn);
            }
        }
        return true;
    };
    GlobalEventProvider.prototype.unMapListenerToEvent = function (eventName, fn, map) {
        var listenersForEvent = map[eventName];
        if (listenersForEvent) {
            var listenerIndex = listenersForEvent.indexOf(fn);
            if (listenerIndex > -1) {
                listenersForEvent.splice(listenerIndex, 1);
                if (listenersForEvent.length === 0) {
                    delete map[eventName];
                }
                return true;
            }
        }
        return false;
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesCore.dispatcher),
        tslib_1.__metadata("design:type", EventDispatcher_1.EventDispatcher)
    ], GlobalEventProvider.prototype, "_dispatcher", void 0);
    GlobalEventProvider = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], GlobalEventProvider);
    return GlobalEventProvider;
}());
exports.GlobalEventProvider = GlobalEventProvider;
//# sourceMappingURL=GlobalEventProvider.js.map